import { AnalysisOutputProgrammingCode } from "../ars_ldm";
import { isAnalysisOutputCodeParameter } from "./isAnalysisOutputCodeParameter";
import { isDocumentReference } from "./isDocumentReference";
import { isObjectRecord } from "./isObjectRecord";

/**
 * Type guard to check if a value is an AnalysisOutputProgrammingCode object.
 *
 * @param obj - The value to check.
 * @returns True when the value has a valid AnalysisOutputProgrammingCode shape.
 */
export const isAnalysisOutputProgrammingCodeValue = (
  obj: unknown,
): obj is AnalysisOutputProgrammingCode => {
  if (!isObjectRecord(obj)) return false;

  if (typeof obj.context !== "string") return false;
  if (!["string", "undefined"].includes(typeof obj.code)) return false;

  if (obj.documentRef !== undefined && !isDocumentReference(obj.documentRef)) return false;
  if (
    obj.parameters !== undefined &&
    (!Array.isArray(obj.parameters) ||
      obj.parameters.some((param) => !isAnalysisOutputCodeParameter(param)))
  )
    return false;

  return true;
};
